import React from 'react'
import './FooterLeftArea.css'
import footerLogo from '../../images/logo.png'
import SocialLinkCard from './SocialLinkCard'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import InstagramIcon from '@material-ui/icons/Instagram'
import YouTubeIcon from '@material-ui/icons/YouTube'

const FooterLeftAreaCard = () => {
    return (
        <div className="FooterLeftArea">
            <img src={footerLogo} alt="" className="footerLogo"/>
            <p className="FooterText">Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda nesciunt quis provident.</p>
            <ul className="socialLink">
                <SocialLinkCard
                    socailIcon = {<FacebookIcon />}
                    socailLink = "#"
                />
                <SocialLinkCard
                socailIcon = {<TwitterIcon />}
                socailLink = "#"
                />
                <SocialLinkCard
                socailIcon = {<LinkedInIcon />}
                socailLink = "#"
                />
                <SocialLinkCard
                socailIcon = {<InstagramIcon />}
                socailLink = "#"
                />
                <SocialLinkCard
                socailIcon = {<YouTubeIcon />}
                socailLink = "#"
                />
            </ul>
        </div>
    )
}

export default FooterLeftAreaCard
